import { DatePicker } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

import { StyledDatePicker } from "./styles";

interface DatePickerProps {
  fieldId: string;
}

function DatePickerField({ fieldId }: DatePickerProps) {
  const findFieldById = useFormData((fd) => fd.findFieldById);
  const { translatorFor, dataTestIdPrefix } = useFormDataContext();

  const field = findFieldById(fieldId);

  const value = field.value.asString();
  const currentDate = value.value() || value.defaultValue();
  const dateValue = currentDate ? dayjs(currentDate, "YYYY-MM-DD") : null;

  const writable = field.writable;

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);

  const handleDateChange = (newValue: Dayjs | null) => {
    const newDate = newValue?.format("YYYY-MM-DD") || "";
    field.setValue(newDate);
  };

  return (
    <StyledDatePicker>
      <DatePicker
        clearable={true}
        dataTestId={`${dataTestIdPrefix}-${field.id()}`}
        label={label.toString()}
        isDisabled={!writable}
        onChange={handleDateChange}
        value={dateValue}
      />
    </StyledDatePicker>
  );
}

export default DatePickerField;
